import { ReactElement } from 'react';
import {
  alpha,
  Box,
  Divider,
  Stack,
  StackProps,
  Typography,
} from '@mui/material';

import { LOADING_PLACEHOLDER } from 'modules/common/const';

interface IInfoItemProps extends Pick<StackProps, 'sx'> {
  label: string;
  value: string | number;
  additionalValue?: string | number;
  color?: 'primary' | 'secondary' | 'other';
  isLoading?: boolean;
}

export function InfoItem({
  label,
  value,
  color = 'primary',
  additionalValue,
  sx,
  isLoading,
}: IInfoItemProps): ReactElement {
  return (
    <Stack
      alignItems="center"
      direction="row"
      flexWrap="wrap"
      spacing={1.5}
      sx={sx}
    >
      <Box
        component="i"
        sx={theme => {
          return {
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: theme => {
              switch (color) {
                case 'primary':
                  return theme.palette.orange.main;
                case 'secondary':
                  return theme.palette.primary.dark;
                default:
                  return '#303030';
              }
            },
            border:
              color === 'other'
                ? `1px solid ${alpha(theme.palette.common.white, 0.3)}`
                : undefined,
          };
        }}
      />

      <Typography sx={{ fontWeight: 500 }}>{label}</Typography>

      <Typography sx={{ fontWeight: 500, color: 'text.secondary' }}>
        {isLoading ? LOADING_PLACEHOLDER : value}
      </Typography>

      {additionalValue && !isLoading && (
        <>
          <Divider orientation="vertical" />

          <Typography sx={{ fontWeight: 500, color: 'text.secondary' }}>
            {additionalValue}
          </Typography>
        </>
      )}
    </Stack>
  );
}
